export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5145.c413ac46.jpg";